import React from 'react';

import { useTranslation } from '../i18n';
import { StaticPageLayout } from '../layouts/static-page.layout';
import { Button } from '../components/element';

const ApiPage = () => {
  const [t] = useTranslation('api');

  return (
    <StaticPageLayout ns="api" title="api.title">
      <div className="mb-20">
        <img src="/static/pages/api/top-banner.png" alt="Smartpost" width="100%" />
      </div>

      <div style={{ margin: '0 15%' }}>
        <p>{t('api.text')}</p>
      </div>

      <div className="mb-20" style={{ textAlign: 'center' }}>
        <Button
          className="mb-20"
          type="warning"
          style={{ padding: '12px 70px' }}
          onClick={() => window.open('mailto:api@smart-forwarding.com', 'blank')}
        >
          {t('api.btn')}
        </Button>
      </div>

      <div className="mb-20">
        <img src="/static/pages/api/bottom-banner.png" alt="Smartpost" width="100%" />
      </div>
    </StaticPageLayout>
  );
};

ApiPage.getInitialProps = async () => ({
  namespacesRequired: ['common', 'api'],
});

export default ApiPage;
